/**
 * Append a cache-busting `t=<timestamp>` query parameter to a URL.
 *
 * Uses `&` when the URL already carries a query string (for instance a
 * postfixed SAS token), so the result is never ".../file.json?t=123?si=...".
 */
export function withCacheBuster(url: string, now: number = Date.now()): string {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}t=${now}`;
}
